module.exports = __webpack_public_path__ + "img/30t.prt.70c9790c.jpg";